"use client"

import { createContext, useState, useEffect, useContext } from "react"

// Create context
const AuthContext = createContext()



// Provider component
export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null)
  const [loading, setLoading] = useState(true)

// const url = "http://localhost:5500/api/auth"
  const url = "/api/auth"

  // Load user from localStorage on mount
  useEffect(() => {
    const storedUser = localStorage.getItem("currentUser")

    if (storedUser) {
      setCurrentUser(JSON.parse(storedUser))
    }

    setLoading(false)
  }, [])

  // Save user to localStorage whenever it changes
  useEffect(() => {
    if (currentUser) {
      localStorage.setItem("currentUser", JSON.stringify(currentUser))
    } else {
      localStorage.removeItem("currentUser")
    }
  }, [currentUser])

  // Register a new user
  const register = async (name, email, password) => {
    const newUser = {
      id: Date.now().toString(),
      name,
      email,
      password, // In a real app, you would hash this password
      createdAt: new Date().toISOString(),
    }

    const response = await (await fetch(`${url}/newuser`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newUser),
    })).json()

    if (response.error) {
      alert(response.msg)
    }else {	
      alert("Usuário cadastrado com sucesso!")
      setCurrentUser(response.user)
    }
  }

  // Login user
  const login =async (email, password) => {
    const response = await (await fetch(`${url}/loginUser`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    })).json()

    if(response.error) {
      alert(response.msg)
    }else {
      alert("Login realizado com sucesso!")
      setCurrentUser(response.user)
    }
  }

  // Logout user
  const logout = () => {
    setCurrentUser(null)
  }

  return (
    <AuthContext.Provider
      value={{
        currentUser,
        loading,
        register,
        login,
        logout,
        isAuthenticated: !!currentUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

// Custom hook to use the context
export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider")
  }
  return context
}

